import React, { useState } from 'react';
import Select from 'react-select';

const RequestLeaveModal = ({ isOpen, setIsOpen }) => {
    const leaveOptions = [
        { value: 'paid', label: 'Paid Leave' },
        { value: 'casual', label: 'Casual Leave' },
        { value: 'sick', label: 'Sick Leave' },
        { value: 'maternity', label: 'Maternity Leave' },
        { value: 'paternity', label: 'Paternity Leave' },
        { value: 'unpaid', label: 'Unpaid Leave' },
        { value: 'marriage', label: 'Marriage Leave' },
        { value: 'public_holiday', label: 'Public Holiday' },
    ];
    

    // Move useState hooks above the early return
    const [selectedLeave, setSelectedLeave] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [description, setDescription] = useState('');

    if (!isOpen) return null; // This is fine now because hooks are already declared

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Leave Request Submitted:", {
            typeOfLeave: selectedLeave,
            fromDate,
            toDate,
            description,
        });

        // Close modal after submission
        setIsOpen(false);
    };

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">Leave Request</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    {/* Type of Leave */}
                    <div className="oms-form-group">
                        <label htmlFor="leaveType" className="oms-form-label">
                            Type of Leave
                        </label>
                        <Select
                            options={leaveOptions}
                            placeholder="Select leave type"
                            onChange={setSelectedLeave}
                        />
                    </div>

                    <div className="oms-date-group">
                        {/* From Date */}
                        <div className="oms-form-group">
                            <label htmlFor="fromDate" className="oms-form-label">
                                From Date
                            </label>
                            <input
                                type="date"
                                id="fromDate"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        {/* To Date */}
                        <div className="oms-form-group">
                            <label htmlFor="toDate" className="oms-form-label">
                                To Date
                            </label>
                            <input
                                type="date"
                                id="toDate"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Description */}
                    <div className="oms-form-group">
                        <label htmlFor="description" className="oms-form-label">
                            Description
                        </label>
                        <textarea
                            id="description"
                            placeholder="Enter description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    {/* Buttons */}
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Request</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RequestLeaveModal;
